import { FC } from 'react';
import { useLocation } from 'react-router-dom';

import { SettingsPageMetadata } from '@/shared';

const Metadata: FC = () => {
    const location = useLocation();
    const view = location.pathname.endsWith('/alerts') ? 'Alerts' : 'General';

    return <SettingsPageMetadata scope='Account' segments={[view, 'Notifications']} />;
};

export default Metadata;
